(ns admin.events.containers.activity-reports-director
  (:require [clojure.set]
            [kyber.router :refer [ensure-resource-v2]]
            [kyber.events.eql :as eql]
            [kyber.events.utils :refer [kyber-event-fx]]
            [re-frame.core :as re-frame]
            [kyber.lib.kyber-db :as kyber-db]
            [admin.router.utils :as au]
            [potpuri.core :as pot]))

(when ^boolean js/goog.DEBUG
  (def event-doc-fetch-container-data-success
    {:description "Get container page success"
     :changelog
     [{:date "17MAR21"
       :event-version 0
       :data {}}]}))

(defn- format-activity-director-report
  [report external-user-id activity-uuid]
  (assoc report
         :external-user/id external-user-id
         :activity/uuid activity-uuid))

(defn- format-reportee
  [external-user {:keys [id manager-activity-report activity-uuid]}]
  (-> external-user
      (dissoc :>/activity-stats.owner)
      (assoc :external-user/activity-director-reports [(format-activity-director-report manager-activity-report
                                                                                        id
                                                                                        activity-uuid)])))

(defn- format-director
  [{manager-activity-report :>/activity-stats.owner
    :external-user/keys [id]
    :as external-user}
   activity-uuid]
  (-> external-user
      (format-reportee (pot/map-of id manager-activity-report activity-uuid))
      (update :external-user/staff-managers
              (fn [staff]
                (mapv (fn [{manager-activity-report :>/activity-stats.staff
                           :external-user/keys [id]
                           :as external-user}]
                        (format-reportee external-user (pot/map-of id manager-activity-report activity-uuid)))
                      staff)))
      (clojure.set/rename-keys {:external-user/staff-managers :external-user/staff})))

(defn fetch-container-data-success
  [{:keys [db]} [event-name {:keys [activity-uuid]} {current-user :app.current-session/user
                                                     external-manager :>/external-user}]]
  {:db (cond-> db
         :always
         (kyber-db/tx-record {:model :external-user} (format-director (or external-manager current-user)
                                                                      activity-uuid))

         ;; TODO In the future when all state is managed in kyber-db, this data will already
         ;;      exist there so we will not have to explicitly transact that here.
         (some? current-user)
         (kyber-db/tx-record {:model :current-user}
                             {:current-user/id "current-user"
                              :current-user/external-user-id (:external-user/id current-user)}))
   :dispatch-n [[:analytics/save-datapoint {:event event-name
                                            :event-version 0}]]})

(kyber-event-fx ::fetch-container-data-success fetch-container-data-success)

(when ^boolean js/goog.DEBUG
  (def event-doc-fetch-container-data-failure
    {:description "Get container page failure"
     :changelog
     [{:date "17MAR21"
       :event-version 0
       :data {}}]}))

(defn fetch-container-data-failure
  [{:keys [db]} [event-name _ _err]]
  {:db db
   :dispatch-n [[:analytics/save-datapoint {:event event-name
                                            :event-version 0}]]})

(kyber-event-fx ::fetch-container-data-failure fetch-container-data-failure)

(when ^boolean js/goog.DEBUG
  (def event-doc-fetch-container-data
    {:description "Get container page request"
     :changelog
     [{:date "17MAR21"
       :event-version 0
       :data {}}]}))

(def ^:private base-external-user-query
  [:external-user/given-name
   :external-user/family-name
   :external-user/id
   :external-user/is-manager?])

(def ^:private external-user-manager-activity-report
  [:activity-session/average-team-readiness
   :activity-session/average-readiness
   :external-user.manager/staff-count
   :external-user.manager/staff-high-readiness-count
   :external-user.manager/staff-medium-readiness-count
   :external-user.manager/staff-low-readiness-count
   :external-user.manager/staff-incompleter-count
   :external-user.manager/indirect-staff-count
   :external-user.manager/indirect-staff-high-readiness-count
   :external-user.manager/indirect-staff-medium-readiness-count
   :external-user.manager/indirect-staff-low-readiness-count
   :external-user.manager/indirect-staff-incompleter-count])

(defn- external-user-query
  [activity-uuid placeholder-key]
  (conj base-external-user-query
        {`(~placeholder-key {:activity/uuid ~activity-uuid})
         external-user-manager-activity-report}))

(defn fetch-container-data
  [{:keys [db]} [event-name {:keys [lmei]}]]
  (let [{:keys [activity-uuid curriculum-uuid]}
        (get-in db [:router :route-params])

        route-lmei
        (get-in db [:router :route-query "lmei"])

        query
        (conj (external-user-query activity-uuid :>/activity-stats.owner)
              {:external-user/staff-managers (external-user-query activity-uuid :>/activity-stats.staff)})]
    (cond-> {:db db
             :dispatch-n [[:analytics/save-datapoint {:event event-name
                                                      :event-version 0}]]
             :request
             (eql/request
              db
              {:name event-name
               :params (if (some? (or lmei route-lmei))
                         `[{(:>/external-user {:external-user/id ~(or lmei route-lmei)}) ~query}]
                         `[{:app.current-session/user ~query}])
               :on-success [::fetch-container-data-success {:activity-uuid activity-uuid}]
               :on-failure [::fetch-container-data-failure]})}
      (some? lmei)
      (update :dispatch-n into [[:router/nav-to
                                  (str (au/admin-path :reports-director
                                                      :curriculum-uuid curriculum-uuid
                                                      :activity-uuid activity-uuid)
                                       "?lmei=" lmei)]
                                [:request/reset event-name]]))))

(kyber-event-fx ::fetch-container-data fetch-container-data)

(def ensure-activity-reports-director
  "Fetches data for the activity line manager reports page"
  (partial ensure-resource-v2 ::fetch-container-data
           #(re-frame/dispatch [::fetch-container-data %])))
